import React, { useState } from 'react';
import ButtonsIncDec from '../ButtonsIncDec';
import { TbMessage2Question, TbUser, TbUserSquareRounded } from "react-icons/tb";
import { formatCurrency } from '../../../Utils/Formatters';
import Badge from '../Badge';
import { useLocation } from 'react-router-dom';
import { CART_ITEM_STATUS_DONE, CART_ITEM_STATUS_MOUNTING, CART_ITEM_STATUS_PENDING, CART_ITEM_STATUS_RELEASED_SHIPMENT } from '../../../Utils/Constants/Cart';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import { useCartHook } from '../../../Hooks/CartHook';
import { useLoginContext } from '../../../Contexts/LoginContext';
import { useCartContext } from '../../../Contexts/CartContext';
import { useStoreHook } from '../../../Hooks/StoreHook';

interface CardProductCartProps {
  product: any;
  // onInc: CallableFunction;
  // onDec: CallableFunction;
  // onDelete?: CallableFunction;
  showButtonsIncDec?: boolean;
  cartFinished?: boolean;
}

const CardProductCart = ({
  product,
  // onDec,
  // onInc,
  // onDelete,
  showButtonsIncDec = true,
  cartFinished = false
}: CardProductCartProps) => {

  const { isStoreCounter, isDirectSale } = useOrderTypeContext();
  const { loadingUpdateQuantity, loadingUpdateQuantityProductId } = useCartContext();
  const { getLinkToHome } = useStoreHook();

  const location = useLocation()
  const [isCheckout] = useState(location.pathname === `${getLinkToHome()}/checkout`)

  const isCanceled = product.status === 0;
  const textCanceled = isCanceled && 'text-gray-400';
  const classCanceled = isCanceled && `line-through ${textCanceled}`;

  const getTypeByStatus = (status: number): string => {
    const statusMap: Record<number, string> = {
      [CART_ITEM_STATUS_PENDING]: 'info',
      [CART_ITEM_STATUS_MOUNTING]: 'info',
      [CART_ITEM_STATUS_RELEASED_SHIPMENT]: 'info',
      [CART_ITEM_STATUS_DONE]: 'success',
    }
    return statusMap[status] ?? ''
  }
  const getLabelByStatus = (status: number): string => {
    const statusMap: Record<number, string> = {
      [CART_ITEM_STATUS_PENDING]: 'Enviado',
      [CART_ITEM_STATUS_MOUNTING]: 'Enviado',
      [CART_ITEM_STATUS_RELEASED_SHIPMENT]: isStoreCounter ? 'Enviado' : product.status_name,
    }
    return statusMap[status] ?? product.status_name
  }

  const { changeQuantityProduct, deleteProduct } = useCartHook();
  const { token } = useLoginContext();

  const handleUpdate = (quantity: number) => {
    changeQuantityProduct(product.id, quantity, token);
  }

  const handleDelete = (itemConferenceId: number) => {
    deleteProduct(product.id, token);
  }


  return (
    <div className={'flex flex-row gap-1.5 md:gap-2 justify-between items-center py-1.5 w-full'}>
      <div className='flex justify-between items-center gap-3 w-full'>

        <div className={`self-start leading-none text-right w-8 font-bold ${classCanceled}`}>{ product.quantity }x</div>

        <div className='flex items-center w-full gap-2'>
          <div className='flex flex-col w-full self-start'>
            <span className={`font-semibold leading-4 ${classCanceled}`}>{product.name}</span>
            {product.subitems &&
              <div className='mt-1 text-xs'>
                {product.subitems?.map((item: any, index: number) =>
                    <div className={`flex gap-1 leading-none ${isCanceled ? textCanceled : 'text-gray-500'}`} key={index}>
                      <span className='w-full leading-4'>
                        <span className="mx-0.5"><span>{item.quantity}x</span> {item.name}</span>
                        <span className='inline-flex'>{ item.total_with_discount > 0 && `(${formatCurrency(item.total_with_discount)})`}</span>
                      </span>
                  </div>
                )}
              </div>
            }

            {(product.observation && !isCanceled) &&
              <div className='flex gap-0.5 text-gray-400 text-xs md:text-sm mt-1'>
                <div><TbMessage2Question /></div>
                <span className='leading-none'>{product.observation}</span>
              </div>
            }

            {isStoreCounter &&
              <span className='mt-1 flex items-center gap-0.5 text-xs text-gray-400 leading-none'>
                {product.seller
                  ? <><span><TbUserSquareRounded /></span><span>Feito por {product.seller.name} em {product.created_at}</span></>
                  : <><span><TbUser /></span><span>Feito por você em {product.created_at}</span></>
                }
              </span>
            }

            {(((isStoreCounter && !cartFinished) || isDirectSale) && product.status_name && !isCanceled && !isCheckout) &&
              <span className='-mt-0.5'>
                  <Badge type={getTypeByStatus(product.status)} outline>{ getLabelByStatus(product.status) }</Badge>
              </span>
            }
          </div>

          <div className={`flex-col text-right leading-none flex text-nowrap text-sm ${showButtonsIncDec && 'pt-0'} ${isCanceled ? classCanceled : 'text-gray-500'}`}>
            {product.total_discount > 0 && <span className='line-through text-gray-400 text-xs'>{formatCurrency(product.total * product.quantity)}</span>}
            <span className={`leading-none ${product.total_discount > 0 ? 'text-xs font-semibold' : ''}`}>{formatCurrency(product.total_with_discount * product.quantity)}</span>
          </div>

        </div>
      </div>

      {showButtonsIncDec &&
          <div className='text-sm h-8 w-22 px-0'>
            <ButtonsIncDec
              onDec={handleUpdate}
              onInc={handleUpdate}
              onDelete={handleDelete}
              showDeleteOnZero
              quantityMin={0}
              initialQuantity={product.quantity}
              product={product}
              className='h-full'
              delay={500}
              loading={(!loadingUpdateQuantityProductId && loadingUpdateQuantity) || (loadingUpdateQuantityProductId === product.id && loadingUpdateQuantity)}
              disabled={(!loadingUpdateQuantityProductId && loadingUpdateQuantity) || (loadingUpdateQuantityProductId === product.id && loadingUpdateQuantity)}
            />
          </div>
        }

  </div>
  )
}

export default CardProductCart;